import { useSelector } from "react-redux";
import { selectSessionID } from "../redux/project-slice";

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useUniqueProjectID = () => useSelector(selectSessionID);
